/*import { updateDirectives, directives } from "./app/directives.js";
import { mountComponents, components } from "./app/components.js";*/

import { listOfComponents } from "./app/components.js";
import { listOfElements } from "./app/elements.js";
import { listOfDirectives } from "./app/directives.js";
import { ScrollService, LazyDomService, LazyImageService, VersionService, ScriptService } from './app/services.js';
import { library } from "./app/services/Script.js";
import utils from './app/utils/utils.js';

import './app/events.js';

const loadAppOnAction = ['mousedown', 'mousemove', 'touchstart', 'scroll', 'keydown'];
const loadErrorPolicy = ["err", "warn", "strict"][0];



const Core = {

    utils: {
        ...utils
    },

    init() {

        const root = document.querySelector('[data-app]');
        this.root = root;
        
        const reactiveData = this.reactive(this.data);
        root.__x = reactiveData;
        this.data = reactiveData;
        
        // this.utils = utils;

        this.updateDom(root);
        this.mountDirectives(root);
        this.mountComponents(root);
        this.mountElements(root);
        this.mountMethods(root);

        this.lazy.image.init();
        this.lazy.dom.init();
    },



    components: {
        ...listOfComponents
    },
    
    elements: {
        ...listOfElements
    },
    
    version: {
        ...VersionService
    },
    scripts: {
        ...ScriptService
    },
    scroll: {
        ...ScrollService
    },

    lazy: {
        dom: {
            ...LazyDomService
        },
        image: {
            ...LazyImageService
        }
    },

    directives: {
        ...listOfDirectives
    },

    reactive(data) {
        const watchers = {};

        const proxy = new Proxy(data, {
            set(target, key, value) {
                // Only proceed if the value actually changed
                if (target[key] === value) return true;

                target[key] = value;

                // Notify watchers (existing functionality)
                if (watchers[key]) {
                    watchers[key].forEach(cb => cb(value));
                }

                // Also trigger bindings updates
                const root = document.querySelector('[data-app]');
                if (root && root.__bindings && root.__bindings[key]) {
                    root.__bindings[key].forEach(cb => cb(value));
                }

                return true;
            }
        });

        // Rest of the $watch and $unwatch methods remain the same
        proxy.$watch = (key, callback, { once = false } = {}) => {
        if (!watchers[key]) watchers[key] = [];

        const wrappedCb = once
            ? (val) => { callback(val); proxy.$unwatch(key, wrappedCb); }
            : callback;

        // Don't add duplicate
        if (!watchers[key].includes(wrappedCb)) {
            watchers[key].push(wrappedCb);
        }

        return () => proxy.$unwatch(key, wrappedCb);
        };


        proxy.$unwatch = (key, callback) => {
            if (watchers[key]) {
                watchers[key] = watchers[key].filter(cb => cb !== callback);
            }
        };

        return proxy;
    },

    computed(computeds = {}) {
        const data = this.data;
        for (const key in computeds) {
            Object.defineProperty(data, key, {
                get: function () {
                    return computeds[key].call(data);
                },
                enumerable: true,
            });
        }
    },

    updateDom(rootElement) {
        if (!rootElement) return;
        const context = rootElement.__x;

        Object.entries(listOfDirectives).forEach(([name, directive]) => {
            const selector = directive.selector;
            if (!selector || directive.reactive == false) return;
            rootElement.querySelectorAll(selector).forEach(el => {
                directive.run(el, context, rootElement);
            });
        });
        
    },

    mountComponents(rootElement = document) {
        Object.entries(this.components).forEach(([name, component]) => {
            const selector = component.selector;
            if (!selector || component.reactive === false) return;
            rootElement.querySelectorAll(selector).forEach(el => {
                console.log(`Mounting component: ${name}`);
                if (!el.__componentInitialized) {
                    el.__componentInitialized = true;
                    component.run(el, el.__x || rootElement.__x, rootElement);
                }
            });
        });
    },

    mountElements(rootElement = document) {
        Object.entries(this.elements).forEach(([name, element]) => {
            const selector = element.selector;
            if (!selector || element.reactive === false) return;
            rootElement.querySelectorAll(selector).forEach(el => {
                console.log(`Mounting element: ${name}`);
                if (!el.__elementInitialized) {
                    el.__elementInitialized = true;
                    element.run(el, el.__x || rootElement.__x, rootElement);
                }
            });
        });
    },

    updateComponents(rootElement) {
        if (!rootElement) return;
        Object.entries(this.components).forEach(([name, component]) => {
            const selector = component.selector;
            if (!selector || !component.reactive) return;

            rootElement.querySelectorAll(selector).forEach(el => {
                component.run(el, rootElement.__x, rootElement);
            });
        });
    },
    
    mountMethods(rootElement) {
        const methods = {};
        for (const [methodName, methodFn] of Object.entries(this.methods)) {
            methods[methodName] = (...args) => {
                methodFn.call(rootElement.__x, ...args);
                this.updateDom(rootElement);
            }
        }

        Object.assign(rootElement.__x, methods);
    },

    mountDirectives(rootElement) {
        if (!rootElement) return;
        rootElement.querySelectorAll('[x-on], [data-on]').forEach((el) => {
            this.directives.on.run(el, rootElement.__x, rootElement);
        });
    }


};

// Todo:
// Change Core to App
// Change App to Page

const App = {
    ...Core,
    // Todo: transport init() into Core


    preload(callback) {
        return this.scripts.before(callback);
    },
    library,            // alias of the named export so App.library('gsap') works too
    data: {
        count: 20
    },
    methods: {
        increment() {
            this.count++;
        }
    }
};

window.App = App;
window.library = library;